export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function Badge(props: BadgeProps) {
  const { className, children, ...restProps } = props;
  return (
    <span
      {...restProps}
      className={`inline-flex aspect-square items-center justify-center text-center rounded-full bg-lf-blue-dark px-2 py-0.5 text-xs font-medium text-gray-50 ${className}`}
    >
      {children}
    </span>
  );
}
